"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MobileModFlyoutContainer;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _flyout = _interopRequireDefault(require("@ux/flyout"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("../motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentContainer",
  class: "core-cgna94i"
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "core-c1w25uc3",
  vars: {
    "c1w25uc3-6": [({
      open
    }) => open ? 1 : 0],
    "c1w25uc3-13": [({
      open
    }) => open ? 'translateY(0px)' : 'translateY(100vh)']
  }
});
const FlyoutMobileOverlay = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FlyoutMobileOverlay",
  class: "core-f1f7kisj",
  vars: {
    "f1f7kisj-4": [({
      open
    }) => open ? 1 : 0]
  }
});
const Flyout = /*#__PURE__*/(0, _react2.styled)(_flyout.default)({
  name: "Flyout",
  class: "core-f1ap6vku"
});

/**
 * Flyout
 * @param {Object} props React props
 * @param {string} props.id Unique identifier for the flyout
 * @param {boolean} props.isOpen Whether the flyout is open
 * @param {Function} props.closeHandler Function to call when the flyout should close
 * @param {Object} props.portalElem Element to render the flyout into
 * @param {React.Ref} props.anchorRef Reference to the anchor element for positioning
 * @param {React.ReactNode} props.children Content to display inside the flyout
 * @param {Object} props.uxFlyoutProps Additional properties for the UXFlyout component
 * @param {string} [props.className] Additional class names for styling
 * @param {string} [props.partial] Optional partial identifier for the flyout
 * @returns {React.ReactElement} Flyout component
 * @public
 */
function MobileModFlyoutContainer({
  id,
  isOpen,
  closeHandler = () => null,
  portalElem,
  anchorRef,
  children,
  uxFlyoutProps,
  className,
  partial = ''
}) {
  const MAX_FLYOUT_MOBILE_BREAKPOINT = _patternLibraryUtils.size.tabletLg;
  const FLYOUT_ANIMATION_GAP = 50;
  const contentRef = (0, _react.useRef)(null);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const [isMobileFlyout, setIsMobileFlyout] = (0, _react.useState)(width < MAX_FLYOUT_MOBILE_BREAKPOINT);
  const [animationIsActive, setAnimationIsActive] = (0, _react.useState)(false);

  /* activates animation with a effect so that there is a slight delay between the first flyout render
  and props that control the transition attributes. This will allow animations to trigger as expected */
  (0, _react.useEffect)(() => {
    const timeout = setTimeout(() => {
      setAnimationIsActive(isOpen);
    }, FLYOUT_ANIMATION_GAP);
    return () => clearTimeout(timeout);
  }, [isOpen]);
  (0, _patternLibraryUtils.useKeydown)('ESCAPE', closeHandler);
  (0, _patternLibraryUtils.useClickOutside)(contentRef.current, closeHandler, 'mousedown');
  (0, _react.useEffect)(() => {
    setIsMobileFlyout(width < MAX_FLYOUT_MOBILE_BREAKPOINT);
  }, [width, MAX_FLYOUT_MOBILE_BREAKPOINT]);

  // Disable Scroll When Flyout Open on Mobile
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined' && isOpen && isMobileFlyout) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'initial';
    };
  }, [isOpen, isMobileFlyout]);
  return /*#__PURE__*/_react.default.createElement(Flyout, (0, _extends2.default)({
    id: id
  }, uxFlyoutProps, {
    anchorRef: isOpen && anchorRef,
    portalElem: portalElem,
    className: `${className} ${animationIsActive ? 'open' : ''}`,
    open: animationIsActive
  }), /*#__PURE__*/_react.default.createElement(FlyoutMobileOverlay, {
    open: animationIsActive,
    className: "mobile-overlay",
    "data-partial": partial
  }), /*#__PURE__*/_react.default.createElement(ContentContainer, null, /*#__PURE__*/_react.default.createElement(Content, {
    open: animationIsActive,
    "aria-modal": isMobileFlyout,
    role: "dialog",
    ref: contentRef,
    "data-partial": partial
  }, children)));
}
MobileModFlyoutContainer.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  isOpen: _propTypes.default.bool,
  closeHandler: _propTypes.default.func,
  anchorRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.object
  })]),
  portalElem: _propTypes.default.object,
  children: _propTypes.default.node,
  uxFlyoutProps: _propTypes.default.object,
  style: _propTypes.default.object,
  partial: _propTypes.default.string
};